type Listener = (count: number) => void;

let activeTransferCount = 0;
const listeners = new Set<Listener>();

function notify(): void {
  for (const listener of listeners) {
    listener(activeTransferCount);
  }
}

export function beginActiveTransfer(): void {
  activeTransferCount += 1;
  notify();
}

export function endActiveTransfer(): void {
  activeTransferCount = Math.max(0, activeTransferCount - 1);
  notify();
}

export function hasActiveTransfer(): boolean {
  return activeTransferCount > 0;
}

export function subscribeActiveTransfers(listener: Listener): () => void {
  listeners.add(listener);
  listener(activeTransferCount);
  return () => {
    listeners.delete(listener);
  };
}

export function resetActiveTransfersForTests(): void {
  activeTransferCount = 0;
  listeners.clear();
}
